/**
 * Module dependencies.
 */

import { JSX } from 'react';
import {
  Label,
  Line,
  TechnicalInformationWrapper,
} from './product-description.style';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  product: any;
};

/**
 * Data keys.
 */

const dataKeys = [
  'wind_load_resistance',
  'air_permeability',
  'watertightness',
  'hazardous_substances',
  'load_bearing_capacity',
  'acoustic_performance',
  'thermal_transmittance_uw',
];

/**
 * Export `ProductTechnicalInformation` component.
 */

export function ProductTechnicalInformation({ product }: Props): JSX.Element {
  const { i18n, t: translate } = useTranslation();
  const lang = i18n.language;
  let colorOdd = true;

  return (
    <TechnicalInformationWrapper>
      {dataKeys.map((key) => {
        if (
          (typeof product[key] === 'object' && !product[key][lang]) ||
          !product[key]
        ) {
          return null;
        }

        colorOdd = !colorOdd;

        return (
          <Line colorOdd={colorOdd} key={key}>
            <Label>
              {translate(`catalog.products.technicalInformation.${key}`)}
            </Label>

            <Label bold>{product[key]?.[lang] ?? product[key]}</Label>
          </Line>
        );
      })}
    </TechnicalInformationWrapper>
  );
}
